module.exports = __webpack_public_path__ + "img/art3-img4.bde9bdce.jpeg";